import { render, staticRenderFns } from "./GasbotCommands.vue?vue&type=template&id=26af2cdf&scoped=true"
import script from "./GasbotCommands.vue?vue&type=script&lang=ts"
export * from "./GasbotCommands.vue?vue&type=script&lang=ts"
import style0 from "./GasbotCommands.vue?vue&type=style&index=0&id=26af2cdf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26af2cdf",
  null
  
)

export default component.exports